import { z } from 'zod';

/**
 * POST /api/chat/block - Block a user
 */
export const BlockUserRequestSchema = z.object({
  /** The ID of the user to block */
  userId: z.number(),
});

/**
 * DELETE /api/chat/block - Unblock a user
 */
export const UnblockUserRequestSchema = z.object({
  /** The ID of the user to unblock */
  userId: z.number(),
});

/**
 * GET /api/chat/block - Check blocked status
 */
export const CheckBlockedRequestSchema = z.object({
  /** The ID of the user to check */
  userId: z.string().transform(val => parseInt(val, 10)),
});

/**
 * Success response for block/unblock operations
 */
export const BlockUserSuccessResponseSchema = z.object({
  success: z.literal(true),
  message: z.string().optional(),
});

/**
 * Error response for block operations
 */
export const BlockUserErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
});

/**
 * Response for checking blocked status
 */
export const CheckBlockedResponseSchema = z.object({
  success: z.literal(true),
  /** Whether the current user has blocked this user */
  isBlocked: z.boolean(),
  /** Whether this user has blocked the current user */
  isBlockedBy: z.boolean(),
});

/**
 * Combined response schema for block/unblock operations
 */
export const BlockUserResponseSchema = z.discriminatedUnion('success', [
  BlockUserSuccessResponseSchema,
  BlockUserErrorResponseSchema,
]);

export type BlockUserRequest = z.infer<typeof BlockUserRequestSchema>;
export type UnblockUserRequest = z.infer<typeof UnblockUserRequestSchema>;
export type CheckBlockedRequest = z.infer<typeof CheckBlockedRequestSchema>;
export type BlockUserSuccessResponse = z.infer<typeof BlockUserSuccessResponseSchema>;
export type BlockUserErrorResponse = z.infer<typeof BlockUserErrorResponseSchema>;
export type CheckBlockedResponse = z.infer<typeof CheckBlockedResponseSchema>;
export type BlockUserResponse = z.infer<typeof BlockUserResponseSchema>;
